import { render, staticRenderFns } from "./TaskClaim.vue?vue&type=template&id=ae631bfc"
import script from "./TaskClaim.vue?vue&type=script&lang=js"
export * from "./TaskClaim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports